export const pxToRem = (fontSize: number, baseFontSize: number = 16) => fontSize / baseFontSize;
